import BoxUi from '@components/common/BoxUi'
import { useEffect, useState } from 'react'
import { Button, Col, Modal, Row } from 'antd'
import TitleUi from '@components/common/TitleUi'
import { IoCloseCircle } from 'react-icons/io5'
import styled from 'styled-components'
import { useDispatch, useSelector } from '@redux/store'
import { findDocumentos } from '@redux/slices/documentos'

const ComposicionPortafolios = () => {
    const { token } = useSelector(item => item.sesion);

    const [toggle, setToggle] = useState(false);

    const dispatch = useDispatch();

    useEffect(() => {
        if (!token) return;
        dispatch(findDocumentos());
    }, [dispatch, token]);

    const documentoState = useSelector(state => state.documentos);
    const portalFinancieroDocs =
        documentoState.documentosByCat
        && documentoState.documentosByCat.portal_financiero
        && documentoState.documentosByCat.portal_financiero.length
        && documentoState.documentosByCat.portal_financiero[0];
    const handleClose = () => {
        setToggle(false);
    }
    
    return (
        <BoxUi>
            <TitleUi titulo="Composición del Portafolio" />
            <Row gutter={[21, 21]} align="center">
                <Col>
                    <p className='strong400'>
                        Te invitamos a revisar la composición del portafolio de tus fondos de inversión.
                    </p>
                </Col>
                <Col>
                    <Button onClick={() => setToggle(true)}>
                        Ver
                    </Button>
                </Col>
            </Row>
            <Modal
                width={'100%'}
                centered
                visible={toggle}
                onOk={() => { }}
                onCancel={handleClose}
                footer={false}
                bodyStyle={{ boxShadow: 'none' }}
                style={{ borderRadius: "9pt", overflow: 'hidden', paddingBottom: 0, marginBottom: 0 }}
                closeIcon={
                    <div style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <IoCloseCircle size="2.1em" />
                    </div>
                }>
                <FrameView>
                    {
                        portalFinancieroDocs && portalFinancieroDocs.url
                            ? <iframe src={`${process.env.API_URL}${portalFinancieroDocs.url}#toolbar=0`}  ></iframe>
                            : null
                    }
                </FrameView>
            </Modal>
        </BoxUi>
    );
}

export default ComposicionPortafolios;


const FrameView = styled.div`
    height: 65vh;
    iframe {
        border: 0;
        height: 100%;
        width: 100%;
    }
`